module.exports = __webpack_public_path__ + "static/sport/btn-reg.7269ae8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/euro/btn-reg.gif
// module id = JEWo
// module chunks = 0